import {apiClient} from "@/api/apiClient";
import type {CompanyDTO} from "./CompanyDto";

/**
 * Search companies by pattern.
 * Minimum 3 characters required.
 */
export async function searchCompanies(pattern: string): Promise<CompanyDTO[]> {
    if (pattern.length < 3) {
        return [];
    }
    return apiClient.fetch<CompanyDTO[]>(`Companies/Search/V1?pattern=${encodeURIComponent(pattern)}`);
}